import {useTranslation} from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragAndDropColumn from "./DragAndDropColumn";
import {Stack, Box} from "@mui/material";
import {toast} from "react-toastify";
import ProjectTaskService from "../../services/projectTask.service";
import InteroperabilityService from "../../services/interoperabilty.service";
import { useState, useMemo, useEffect } from "react";

const ITEM_TYPES = {
  CARD: "card",
  TASK: "task"
};

function DragAndDropView({tasks, taskStates, selectedProjects, _setSelectedProjects, projects, _setSelectedIndexTask, _setSelectedTask, _setIdView}) {
  const {t} = useTranslation();
  const [tasksAux, setTasksAux] = useState([]);
  const [columns, setColumns] = useState(taskStates);
  const projectTaskService = useMemo(() => new ProjectTaskService(), []);
  const interoperabilityService = useMemo(() => new InteroperabilityService(), []);

    useEffect(() => {
        //console.log("TASKS", tasks);
        setTasksAux(tasks);
    }, [tasks]);

    const onDragEnd = (result) => {
        const { destination, source, draggableId, type } = result;

        if (!destination || (destination.droppableId === source.droppableId &&destination.index === source.index)) {
          return;
        }

        if (type === ITEM_TYPES.CARD) {
          reorderCards(source, destination, draggableId);
        } else {
            //console.log("source.droppableId: " + source.droppableId);
            //console.log("destination.droppableId: " + destination.droppableId);
          const start = columns[source.droppableId];
          const finish = columns[destination.droppableId];
          if (start.idStatus === finish.idStatus) {
//            reorderTasksWithinCard(
//              start,
//              source.index,
//              destination.index,
//              draggableId
//            );
          } else {
            moveTask(start, finish, source.index, destination.index, draggableId);
          }
        }
    }

    const reorderCards = (source, destination, draggableId) => {
      let parts = draggableId.split(';');
        const newCardOrder = Array.from(columns);
        newCardOrder.splice(source.index, 1);
        newCardOrder.splice(destination.index, 0, parts[0]);
        setColumns(newCardOrder);
    };

    const moveTask = (start, finish, sourceIdx, destinationIdx, draggableId) => {
      // SÓLO CAMBIAR EL STATUS DE LA TAREA
      let parts = draggableId.split(";");
      if (parts.length == 2) {
        projectTaskService.changeStatus(parts[0], finish.idStatus).then(({data: response}) => {
          if (response.internalError != null && response.internalError && response.message != null) {
              toast.error(response.message);
          } else {
            let tasksCopy = tasksAux.slice();
            let taskUpdateIndex = tasksAux.findIndex((t) => t.idProjectTask == parts[0]);
            tasksCopy[taskUpdateIndex]["idStatus"] = finish.idStatus;
            setTasksAux(tasksCopy);
            toast.error(response.message);
            toast.success(t("daily_page.msg_status_change_success"));
            interoperabilityService.reviewProjectElementStatus(parseInt(parts[1])).then(() => {});
          }
        });
      }
    }

    return (
            <Box sx={{backgroundColor: "#d4e3ff", padding: ".5rem"}}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="all-cards" direction="horizontal" type="card">
                {(provided) => (
                    <Box ref={provided.innerRef} {...provided.droppableProps}>
                        <Stack direction="row" spacing={2}>
                        {columns.map((col, index) => (
                            <DragAndDropColumn
                                key={index}
                                index={index}
                                title={col.name}
                                idStatus={col.idStatus}
                                items={tasksAux?.filter((t) => t.idStatus == col.idStatus)}
                                _setSelectedIndexTask={_setSelectedIndexTask}
                                _setSelectedTask={_setSelectedTask}
                                _setIdView={_setIdView}
                            />
                        ))}
                        </Stack>
                    </Box>
                  )}
                 </Droppable>
            </DragDropContext>
            </Box>
    );
}

export default DragAndDropView;